import { useEffect, useState } from "react";
import { Text } from "@core/index";
import WaterLoader from "@packages/components/water-loader";
import { gradientColors, ThemeColor } from "./gradient-colors";

const LoadingDot = ({
  title,
  themeColor,
  fullHeight = true,
}: {
  title: string;
  fullHeight?: boolean;
  themeColor: ThemeColor;
}) => {
  const [progress, setProgress] = useState(0);

  const selectedGradient = gradientColors[themeColor] || gradientColors["blue"];

  useEffect(() => {
    let interval: NodeJS.Timeout;

    interval = setInterval(() => {
      setProgress((prev) => {
        // Normal dağılım - ortada hızlı, başta ve sonda yavaş
        if (prev < 15) return prev + 0.8; // Yavaş başlangıç
        if (prev < 30) return prev + 0.2; // Hızlanma başlangıcı
        if (prev < 45) return prev + 0.4; // Hızlı artış
        if (prev < 60) return prev + 0.5; // En hızlı
        if (prev < 75) return prev + 0.4; // Hızlı azalış
        if (prev < 85) return prev + 0.2; // Yavaşlama
        if (prev < 98) return prev + 0.1; // Son damla
        return prev; // 89'da dur
      });
    }, 50);

    return () => {
      if (interval) clearInterval(interval);
    };
  }, []);

  return (
    <div
      className={
        fullHeight
          ? `min-h-screen h-full flex items-center justify-center ${selectedGradient.background}`
          : ""
      }
    >
      <div className="container max-w-7xl mx-auto px-4 py-4">
        <div className="max-w-4xl mx-auto" data-testid="loading-dot-container">
          <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-lg rounded-2xl shadow-xl px-8 border border-gray-200/50 dark:border-gray-700/50">
            <div className="flex flex-col items-center justify-center py-6">
              <WaterLoader progress={progress} />

              <Text variant="h2" className="mt-8 mb-3 text-center">
                {title}
              </Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingDot;
